export default __webpack_public_path__ + "static/8165-4925f106f7c946af21891d3b42c562e4.jpg";